(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fs-home-hero"] && !Shopify.designMode) return;
  try {
    
function measureHeroHeader(){
 const hero=document.querySelector('[data-fs-home="hero"]');
 const header=document.querySelector('.header');
 if(!hero||!header)return;
 if(hero.fsFitCleanup)hero.fsFitCleanup();
 const announcement=document.querySelector('.fs-announcements');
 const copy=hero.querySelector('.hero-copy');
 let frame=0;
 const measure=()=>{
  cancelAnimationFrame(frame);
  frame=requestAnimationFrame(()=>{
   if(!hero.isConnected)return;
   const headerHeight=header.getBoundingClientRect().height+(announcement?.getBoundingClientRect().height||0);
   document.documentElement.style.setProperty('--fs-mobile-header-height',headerHeight+'px');
   const probe=hero.querySelector('.hero-grid');
   const style=getComputedStyle(probe);
   const room=parseFloat(style.minHeight)||window.innerHeight-headerHeight;
   const padding=parseFloat(style.paddingTop)+parseFloat(style.paddingBottom);
   const mobile=matchMedia('(max-width:700px)').matches;
   const height=mobile?room-padding-copy.getBoundingClientRect().height-parseFloat(style.rowGap)-24:room-padding-24;
   hero.style.setProperty('--fs-hero-stage-height',Math.max(mobile?150:200,Math.min(760,Math.floor(height)))+'px');
  });
 };
 const observer=new ResizeObserver(measure);
 observer.observe(header);if(announcement)observer.observe(announcement);observer.observe(copy);
 window.addEventListener('resize',measure);
 document.fonts?.ready.then(measure);
 measure();
 hero.fsFitCleanup=()=>{observer.disconnect();cancelAnimationFrame(frame);window.removeEventListener('resize',measure);};
}
measureHeroHeader();
document.addEventListener('shopify:section:load',measureHeroHeader);
document.addEventListener('shopify:section:unload',event=>event.target.querySelector('[data-fs-home="hero"]')?.fsFitCleanup?.());

document.addEventListener('click', event => {
  const hero = event.target.closest('[data-hero-calculator]');
  if (!hero) return;
  const dialog = hero.querySelector('dialog');
  const holder = dialog.querySelector('[data-calc-holder]');
  const mode = event.target.closest('[data-calc-mode]');
  if (mode && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && dialog.showModal) {
    event.preventDefault();
    dialog.dataset.mode = mode.dataset.calcMode;
    dialog.querySelector('h2').textContent = mode.textContent;
    dialog.showModal();
    let frame = holder.querySelector('iframe');
    if (!frame) {
      frame = document.createElement('iframe');
      frame.title = 'FUTURE GREEN product and quantity calculator';
      frame.srcdoc = hero.querySelector('[data-calc-document]').content.textContent;
      holder.append(frame);
    } else {
      const route = frame.contentDocument?.querySelector('[data-finder-route="' + dialog.dataset.mode + '"]');
      if (route && route.getAttribute('aria-pressed') !== 'true') route.click();
    }
  } else if (event.target.closest('[data-calc-close]') || event.target === dialog) {
    dialog.close();
  } else if (event.target.closest('[data-calc-reset]')) {
    holder.replaceChildren();
    if (dialog.open) dialog.close();
    hero.querySelector('[data-calc-mode]').focus();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-native-collection"] && !Shopify.designMode) return;
  try {
    
function initProductGroups(root){
root.querySelectorAll('[data-product-groups]').forEach(section=>{
if(section.dataset.groupsReady)return;
section.dataset.groupsReady='true';
const buttons=[...section.querySelectorAll('[data-group]')],cards=[...section.querySelectorAll('[data-group-product]')];
function choose(key,update){
const selected=buttons.find(b=>b.dataset.group===key)||buttons[0];
if(!selected)return;
const handles=new Set((selected.dataset.handles||'').split(','));
buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===selected)));
cards.forEach(card=>card.hidden=selected.dataset.group!=='all'&&!handles.has(card.dataset.groupProduct));
section.querySelector('[data-group-empty]').hidden=cards.some(card=>!card.hidden);

if(update){const url=new URL(location.href);if(selected.dataset.group==='all')url.searchParams.delete('group');else url.searchParams.set('group',selected.dataset.group);history.replaceState(null,'',url);}
}
buttons.forEach(b=>b.addEventListener('click',()=>choose(b.dataset.group,true)));
choose(new URL(location.href).searchParams.get('group')||'all',false);
});
}
initProductGroups(document);
document.addEventListener('shopify:section:load',event=>initProductGroups(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-pdp-hydro-2"] && !Shopify.designMode) return;
  try {
    
function initFsSandSwipe(scope){
scope.querySelectorAll('[data-sand-swipe]').forEach(frame=>{
if(frame.dataset.swipeReady)return;frame.dataset.swipeReady='true';
const input=frame.querySelector('input[type=range]');
const update=()=>{frame.style.setProperty('--split',input.value+'%');input.setAttribute('aria-valuetext',input.value+'% without SAND FIXER, '+(100-Number(input.value))+'% with SAND FIXER');};
input.addEventListener('input',update);update();
});
}
initFsSandSwipe(document);
document.addEventListener('shopify:section:load',event=>initFsSandSwipe(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-pdp-liquid-2"] && !Shopify.designMode) return;
  try {
    
function initFsLiquidGrowth(scope){
  scope.querySelectorAll('.pdp-growth-viewer').forEach(viewer=>{
    if(viewer.dataset.growthReady)return;
    viewer.dataset.growthReady='true';
    const images=[...viewer.querySelectorAll('.pdp-growth-frames img')];
    const buttons=[...viewer.querySelectorAll('[data-growth-stage]')];
    const show=stage=>{
      images.forEach((image,index)=>{
        image.id='pdp-growth-frame-'+index;
        image.hidden=index!==stage;
        if(index===stage)image.loading='eager';
      });
      buttons.forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.growthStage)===stage)));
    };
    buttons.forEach(button=>button.addEventListener('click',()=>show(Number(button.dataset.growthStage))));
    show(3);
  });
}
initFsLiquidGrowth(document);
document.addEventListener('shopify:section:load',event=>initFsLiquidGrowth(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-pdp-liquid-4"] && !Shopify.designMode) return;
  try {
    
function initFsLiquidCompare(scope){
scope.querySelectorAll('[data-liquid-compare]').forEach(compare=>{
if(compare.dataset.compareReady)return;
compare.dataset.compareReady='true';
const input=compare.querySelector('input[type=range]');
const update=()=>{compare.style.setProperty('--split',input.value+'%');input.setAttribute('aria-valuetext',input.value+'% Day 1, '+(100-Number(input.value))+'% Week 6');};
input.addEventListener('input',update);update();
});
}
initFsLiquidCompare(document);
document.addEventListener('shopify:section:load',event=>initFsLiquidCompare(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-product-main"] && !Shopify.designMode) return;
  try {
    
function initFsQuantity(root){
root.querySelectorAll('[data-fs-quantity]').forEach(control=>{
if(control.dataset.ready)return;control.dataset.ready='true';
const input=control.querySelector('input'),buttons=[...control.querySelectorAll('button')];
const sync=()=>buttons.forEach(button=>{const value=Number(input.value),min=Number(input.min)||1,max=input.max?Number(input.max):Infinity;button.disabled=Number(button.dataset.quantityStep)<0?value<=min:value>=max;});
buttons.forEach(button=>button.addEventListener('click',()=>{
if(!input.value||!Number.isFinite(input.valueAsNumber))input.value=input.min||'1';
if(Number(button.dataset.quantityStep)>0)input.stepUp();else input.stepDown();
input.dispatchEvent(new Event('input',{bubbles:true}));input.dispatchEvent(new Event('change',{bubbles:true}));sync();
}));
input.addEventListener('input',sync);input.addEventListener('change',sync);sync();
});
}
const fsRequestedQuantity=Number(new URLSearchParams(location.search).get('quantity'));if(Number.isInteger(fsRequestedQuantity)&&fsRequestedQuantity>0)document.querySelectorAll('[data-fs-quantity] input').forEach(input=>{const min=Number(input.min)||1,step=Number(input.step)||1,max=input.max?Number(input.max):Infinity;input.value=Math.min(max,Math.max(min,min+Math.ceil((fsRequestedQuantity-min)/step)*step));});
initFsQuantity(document);
document.addEventListener('shopify:section:load',e=>initFsQuantity(e.target));

function initFsProductGallery(root){
root.querySelectorAll('[data-fs-product-gallery]').forEach(g=>{
if(g.dataset.ready)return;g.dataset.ready='true';
const track=g.querySelector('.fs-gallery-track'),slides=[...track.children],thumbs=[...g.querySelectorAll('.fs-gallery-thumbs button')];let index=0;
const paint=()=>{thumbs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));g.querySelector('[data-gallery-status]').textContent=(index+1)+' / '+slides.length;};
const go=i=>{index=(i+slides.length)%slides.length;track.scrollTo({left:index*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});paint();};
thumbs.forEach((b,i)=>b.addEventListener('click',()=>go(i)));
g.querySelectorAll('[data-gallery-step]').forEach(b=>b.addEventListener('click',()=>go(index+Number(b.dataset.galleryStep))));
track.addEventListener('scroll',()=>{index=Math.round(track.scrollLeft/track.clientWidth);paint();},{passive:true});
track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1));}});
paint();
});
}
initFsProductGallery(document);
document.addEventListener('shopify:section:load',e=>initFsProductGallery(e.target));

function initFsStickyPurchase(root){
root.querySelectorAll('.fs-native-buy-actions').forEach(actions=>{
if(actions.dataset.stickyReady)return;
actions.dataset.stickyReady='true';
const slot=document.createElement('div');slot.className='fs-buy-slot';actions.before(slot);slot.append(actions);
const controller=new AbortController(),options={passive:true,signal:controller.signal};
let pending=0,normalHeight=actions.getBoundingClientRect().height,pinned=false,headerMoving=false;
const paint=()=>{
pending=0;
const header=document.querySelector('.header');
const headerBottom=header&&['fixed','sticky'].includes(getComputedStyle(header).position)?Math.max(0,Math.min(innerHeight,header.getBoundingClientRect().bottom)):0;
const shouldPin=slot.getBoundingClientRect().bottom<=headerBottom;
if(shouldPin!==pinned){
if(shouldPin){normalHeight=actions.getBoundingClientRect().height;slot.style.height=normalHeight+'px';}
actions.classList.toggle('is-pinned',shouldPin);
if(!shouldPin)slot.style.height='';
pinned=shouldPin;
}
if(pinned)actions.style.setProperty('--fs-buy-top',headerBottom+'px');
if(headerMoving)schedule();
};
const schedule=()=>{if(!pending)pending=requestAnimationFrame(paint);};
document.addEventListener('scroll',schedule,{...options,capture:true});
window.addEventListener('resize',schedule,options);
const resize=new ResizeObserver(schedule);resize.observe(actions);const header=document.querySelector('.header');if(header)resize.observe(header);
if(header){
header.addEventListener('transitionrun',event=>{if(event.target===header&&event.propertyName==='transform'){headerMoving=true;schedule();}},{signal:controller.signal});
const endHeaderMove=event=>{if(event.target===header&&event.propertyName==='transform'){headerMoving=false;schedule();}};
header.addEventListener('transitionend',endHeaderMove,{signal:controller.signal});header.addEventListener('transitioncancel',endHeaderMove,{signal:controller.signal});
}
document.addEventListener('shopify:section:unload',event=>{
if(event.target.contains(slot)){controller.abort();resize.disconnect();cancelAnimationFrame(pending);}
},{signal:controller.signal});
paint();
});
}
initFsStickyPurchase(document);
document.addEventListener('shopify:section:load',event=>initFsStickyPurchase(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
